import { Card } from 'react-bootstrap';
import '../../styles/css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <Card className="card-rounded-edges">
      <Card.Header className="card-header-title-content">
        <Card.Title className="text-center pt-2 pb-0">
          POLITIKA PRIVATNOSTI SAJTA
        </Card.Title>
      </Card.Header>
      <Card.Body className="mb-2">
        <p>
          <Card.Subtitle className="mt-2 mb-3">Opšte odredbe</Card.Subtitle>
        </p>
        <p>
          Prilikom korišćenja sajta{' '}
          <a href="https://www.sokoj.rs/" target="_blank" rel="noreferrer">
            www.sokoj.rs
          </a>
          , moguće je da nam dajete svoje poverljive informacije. Sokoj štiti
          Vašu privatnost i podatke koje dostavite koristi samo u skladu sa
          važećim propisima o poverljivosti podataka, sa svrhom i u obimu koji
          je neophodan za redovno poslovanje.
        </p>
        <p>
          U skladu sa Zakonom o zaštiti podataka o ličnosti, jedna od mera
          zaštite je i ova <b>Politika privatnosti</b>, objavljena kao sastavni
          deo Uslova korišćenja Sajta.
        </p>
        <p>
          Korišćenjem sajta prihvatate našu Politiku privatnosti i potvrđujete
          da ste upoznati sa načinom prikupljanja podataka o ličnosti koje
          ostavite na Sajtu, te da ste saglasni sa njihovom obradom, u skladu sa
          zakonom.
        </p>
        <p>
          <Card.Subtitle className="mt-4 mb-3">
            Upotreba podataka o ličnosti
          </Card.Subtitle>
        </p>
        <p>
          Sokoj prikuplja, čuva i obrađuje Vaše podatke o ličnosti prvenstveno
          kada je to potrebno za obavljanje poslovnih aktivnosti i kada je to
          zakonom dozvoljeno ili ako ste dali svoj pristanak.
        </p>
        <p>
          Možete koristiti Sajt bez direktnog prosleđivanja svojih podataka o
          ličnosti. Za neke usluge, npr. da bismo uspešno obradili Vaš zahtev,
          uspostavili kontakt ili odgovorili na upit, potrebni su nam Vaše ime,
          prezime, adresa, email i broj telefona.
        </p>
        <p>
          Niste dužni da nam date podatke o ličnosti, ali imajte na umu da u
          nekim slučajevima Sokoj neće biti u mogućnosti da ispuni svoju
          zakonsku obavezu niti da stupi u kontakt sa Vama ako odbijete da date
          tražene podatke.
        </p>
        <p>
          Prema{' '}
          <a
            href="https://www.paragraf.rs/propisi/zakon_o_zastiti_podataka_o_licnosti.html"
            target="_blank"
            rel="noreferrer"
          >
            Zakonu o zaštiti podataka o ličnosti
          </a>
          , Vaši podaci o ličnosti prikupljeni na ovaj način jesu poverljivi i
          ostaju čuvani u bazi podataka Sokoja. Poveravanjem svojih podataka o
          ličnosti na Sajtu ni na koji način se ne odričete prava zagarantovanih
          Zakonom o zaštiti podataka o ličnosti, a posebno svog prava da
          zahtevate ispravku ili brisanje svojih podataka o ličnosti iz naše
          baze ako su oni nepotpuni, netačni ili neažurirani ili njihova obrada
          nije u skladu sa odredbama Zakona. Obavezujemo se da, osim u svrhu
          zakonom propisanih obaveza, nećemo drugim licima dati podatke koje smo
          primili.
        </p>
        <p>
          Na osnovu pismenog zahteva dostavljenog na adresu Sokoja (Sokoj –
          Organizacija muzičkih autora Srbije, Mišarska 12-14, 11000 Beograd,
          Srbija), imate pravo da u svako doba opozovete datu saglasnost za
          dalje držanje i obradu Vaših podataka, kao i sva druga zakonom
          predviđena prava ukoliko smatrate da je došlo do nedozvoljene obrade
          podataka (pravo na obaveštenje da li su Vaši podaci o ličnosti
          obrađeni, uvid u podatke, ažuriranje poslatih podataka i dr.).
        </p>
        <p>
          Moguće je da automatski dobijemo podatke koji nisu vezani za određenu
          osobu, kao što su vreme provedeno na Sajtu, stranice koje posećujete
          na Sajtu, tip pretraživača i operativni sistem koji koristite za
          pristup Sajtu. Ovi podaci se analiziraju anonimno, isključivo u
          statističke svrhe.
        </p>
        <p>
          <Card.Subtitle className="mt-4 mb-3">
            Bezbednost podataka
          </Card.Subtitle>
        </p>
        <p>
          Sokoj sve prikupljene podatke čuva i obrađuje uz primenu svih
          standardnih raspoloživih tehničkih i organizacionih mera zaštite
          podataka, u skladu sa zakonom i internim aktima.
        </p>
        <p>
          Sokoj garantuje da će prikupljati samo osnovne podatke o Vama kao
          korisnicima Sajta i podatke neophodne za redovno poslovanje Sokoja.
        </p>
        <p>
          Vaši podaci su dostupni samo zaposlenim licima zaduženim za povereni
          posao. Oni su obavezi da podatke štite, da ih ne koriste u druge svrhe
          i ne daju trećim licima.
        </p>
        <p>
          <Card.Subtitle className="mt-4 mb-3">
            Promene Politike privatnosti
          </Card.Subtitle>
        </p>
        <p>
          Sokoj zadržava pravo da u bilo koje vreme ažurira Uslove korišćenja i
          Politiku privatnosti, bez prethodne najave, a sve izmene stupaju na
          snagu danom objavljivanja na Sajtu.
        </p>
      </Card.Body>
    </Card>
  );
};

export default PrivacyPolicy;
